import {
  MARK_HOLIDAY,
  MARK_HOLIDAY_SUCCESS,
  MARK_HOLIDAY_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const markHolidayReducer = (state = initialState, action) => {
  switch (action.type) {
    case MARK_HOLIDAY:
      return { ...state, loading: true };
    case MARK_HOLIDAY_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case MARK_HOLIDAY_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default markHolidayReducer;
